import { DataBean } from "../DataBean";

export class ProductionOrderStandardImp extends DataBean {



    public async updateProductionOrderStandardImp(idProductionOrder:any,productionOrderDate:any,idEmployee:any,): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateProductionOrderStandardImp_Number_java.util.Date_Number", [idProductionOrder,productionOrderDate,idEmployee]);
    }
    
}